import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-navy-950 py-16 text-white md:py-24" data-id="element-79" data-mp="av39r46tfp6f">
      <div className="mx-auto max-w-5xl" data-id="element-80" data-mp="asz5gl508o5m">
        <div className="px-5 text-center md:px-8" data-id="element-81" data-mp="ftmresedmesz">
          <p className="font-serif text-2xl font-bold text-gold-300" data-id="element-82" data-mp="fsbnmskxl71v">And that’s not all.</p>
          <h2 className="mt-3 font-serif text-[1.85rem] font-extrabold leading-tight sm:text-4xl md:text-5xl" data-id="element-83" data-mp="1t3n9wd17sw3">
            Get <span className="text-gold-400" data-id="element-84" data-mp="5tw0t1sxsjy6">5 additional clinical tools</span> included with your
            blueprint
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-navy-100" data-id="element-85" data-mp="3t06e2moyjx5s">
            These bonuses complement the six core volumes by making common documentation and workflow
            tasks easier to organize — practical resources designed for repeated professional use.
          </p>
        </div>

        <div className="mt-12 space-y-10 md:space-y-14 md:px-8" data-id="element-86" data-mp="3ideke10bxu2r">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-navy-900 ring-1 ring-gold-500/30 md:grid md:grid-cols-2 md:rounded-3xl" data-id="element-87" data-mp="3deacret204ej">
              <div className="relative bg-white" data-id="element-88" data-mp="3r8ukv0vlb7hb">
                <img src={b.image} alt={`${b.title} mockup`} className="block h-auto w-full object-cover md:h-full" data-id="element-89" data-mp="3n4wnaulwy4qd" />
                <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-gold-400 px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-navy-900 shadow-md" data-id="element-90" data-mp="2zgdd29jazhvn">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="38hbh2rtqrpe8" />
                  Bonus {b.number}
                </span>
              </div>
              <div className="px-5 py-7 sm:px-8 md:py-9" data-id="element-92" data-mp="33jifkc3dvjka">
                <h3 className="font-serif text-2xl font-bold leading-snug" data-id="element-93" data-mp="noq7ezchlv1b">{b.title}</h3>
                <p className="mt-2 text-base font-semibold text-gold-300" data-id="element-94" data-mp="ipwtx6x7a415">{b.tagline}</p>
                <p className="mt-3 text-base leading-relaxed text-navy-100" data-id="element-95" data-mp="3cjpq54hqf4qq">{b.description}</p>
                <p className="mt-5 text-sm font-bold uppercase tracking-wide text-white" data-id="element-96" data-mp="3hhhpgjkpht4y">Includes:</p>
                <ul className="mt-3 space-y-2" data-id="element-97" data-mp="3ljcrxredickb">
                  {b.items.map(item => <li key={item} className="flex gap-2.5 text-base" data-id="element-98" data-mp="3qj7iftu8l04u">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-400" strokeWidth={3} aria-hidden="true" data-id="element-99" data-mp="2tsf1ktzhb420" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 rounded-xl bg-navy-950/60 px-4 py-3 text-sm leading-relaxed" data-id="element-100" data-mp="32td6dehqrfln">
                  <span className="font-bold text-gold-300" data-id="element-101" data-mp="37jjuld8ccy3d">Practical benefit: </span>
                  {b.benefit}
                </p>
                {b.note && <p className="mt-3 text-sm italic text-navy-100/80" data-id="element-102" data-mp="2a3wj0v8zaowa">{b.note}</p>}
              </div>
            </article>)}
        </div>

        <div className="px-5" data-id="element-103" data-mp="27jzy1r6zs5bx">
          <SectionCTA dark label="Unlock My 5 Clinical Bonuses Now" data-id="element-104" data-mp="27iyipaiy0woe" />
        </div>
      </div>
    </section>;
}